export default {
  v3OfficialTopUpCenterTitle: 'Официальный центр пополнения счёта',
  v3OfficialTopUpCenterKeyword: 'Официальный центр пополнения счёта',
  v3OfficialTopUpCenterDescription: 'Официальный центр пополнения счёта',
  v3SafeAndFast: 'Безопасно, без рисков, быстрые зачисления',
  v3Shop: 'Магазин',
  v3ShoppingCart: 'Корзина',
  v3MembershipCenter: '(Центр привилегий) Центр Премиум участников',
  v3Login: 'Войти',
  v3Account: 'Аккаунт',
  v3EnterAccountName: 'Введите название аккаунта',
  v3Password: 'Пароль',
  v3EnterPassword: 'Введите пароль',
  v3ForgotPassword: 'Забыл пароль',
  v3EnterUID: 'Введите UID',
  v3OTP: 'Разовый пароль',
  v3EnterOTP: 'Введите разовый пароль',
  v3SelectTopUpCharacter: 'Выберите персонажа для покупки',
  v3SelectServer: 'Выберите сервер',
  v3Confirm: 'Принять',
  v3CharacterNotFound:
    'Если вы не можете найти персонажа, попробуйте сначала войти им в игру, а затем посетите страницу пополнения счета. Если не получится, пожалуйста, напишите в службу поддержки.',
  v3Logout: 'Выход',
  v3SwitchAccount: 'Смена аккаунта',
  v3MyCoupons: 'Мои купоны',
  v3BenefitsCenter: 'Центр привилегий',
  v3TopUpBenefits: 'Бонусы пополнения',
  v3MoreSettings: 'Больше настроек',
  v3RememberLoginStatus: 'Запомнить мой статус входа',
  v3OrderQuery: 'Проверить заказы',
  v3ContactCustomerService: 'Служба поддержки',
  v3LoginWithApp: 'Войти с приложением',
  v3ChooseOtherLoginMethod: 'Выберите другой способ входа',
  v3ConnectingToGameApp: 'Подключение к приложению',
  v3EnsureGameInstalled:
    'Убедитесь, что игра установлена на данном устройстве. Если приложение не отвечает, или вам не удается войти в игру, попробуйте обновить её до последней версии или сменить браузер.',
  v3OpenGame: 'Запустить игру',
  v3DownloadGame: 'Скачать игру',
  v3UpdateGameIfOpenFails:
    'Если вам не удается запустить игру, обновите её в магазине приложений App Store/Google Play.',
  v3ClickToDownloadLatestVersion:
    'Вы также можете скачать последнюю версию игры, нажав кнопку загрузки.',
  v3LoggingIntoOfficialTopUpCenter:
    'Выполняется вход в [Официальный центр пополнения счёта]',
  v3CurrentAccount: 'Текущий аккаунт: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter:
    'Добро пожаловать в Официальный центр пополнения счёта',
  v3OfficialAuthorizedLogin: 'Выполнен авторизованный вход, никаких рисков.',
  v3TermsOfService: 'Условия использования',
  v3PrivacyPolicy: 'Политика конфиденц.',
  v3ThirdPartySocialAccountDescription: 'Касательно аккаунтов социальной сети',
  v3BindSocialAccountInGameFirst:
    'Завершите привязку аккаунта социальной сети к игровому аккаунту в «Центре пользователя», а затем войдите, используя аккаунт социально сети.',
  v3FirstTopUp15PercentOff: 'Получите 15% скидку при первой покупке',
  v3MoreTopUpRebates: 'Больше наград и бонусов при покупке',
  v3LoginToViewOffers: 'Водите, чтобы увидеть скидки',
  v3TopUpEnvironmentChecking: 'Проверка данных пополнения счёта...',
  v3SafeToUse: 'Надёжно и безопасно.',
  v3LimitedTimeBenefits: 'Особое временное предложение',
  v3EventRules: 'Правила события',
  v3MoreEvents: 'Больше событий',
  v3Claim: 'Получить',
  v3Completed: 'Завершено',
  v3GoTo: 'Пойти',
  v3ViewDetails: 'Подробнее',
  v3RecommendedProducts: 'Рекоменд. предметы',
  v3SearchProductName: 'Поиск по названию',
  v3AllCategories: 'Все',
  v3PopularSort: 'Хит',
  v3PriceAscending: 'Цена↑',
  v3PriceDescending: 'Цена↓',
  v3DiamondBonus10Percent: 'Алмазы +10%',
  v3YuanbaoBonus10Percent: 'Слитки +10%',
  v3ExtraBonus10Percent: 'Бонус: 10%',
  v3FirstTopUpDouble: 'Удвоение 1-й покупки',
  v3FirstExtraBonus: 'Бонус 1-й покупки',
  v3ProductDetails: 'Описание продукта',
  v3AddToCart: 'Добавить в корзину',
  v3AddedToCart: 'Добавлено в корзину',
  v3BuyNow: 'Купить сейчас',
  v3NoItemsInCart: 'В корзине нет товаров',
  v3SelectedItemsN: 'Выбрано товаров: (${n})',
  v3RemoveFromCart: 'Удалить из корзины?',
  v3Yes: 'Да',
  v3No: 'Нет',
  v3LimitOnePerPurchase: 'За раз можно купить только один из этих товаров.',
  v3ItemPrice: 'Цена товара',
  v3Tax: 'Налог',
  v3ExtraGift: 'Бонус',
  v3Total: 'Всего',
  v3ProceedToPayment: 'Оплата',
  v3SelectCoupon: 'Выбрать купон',
  v3UnavailableCoupons: 'Недоступные купоны',
  v3OneCouponPerOrder: 'Один купон на заказ',
  v3DiscountCoupon: 'Скидочный купон',
  v3ThresholdCoupon: 'Вычитаемый купон',
  v3MinSpendCoupon: 'Используйте, если сумма превышает xx USD',
  v3MaxDiscountCoupon: 'Скидка до xxxx USD',
  v3LimitedChannel: 'Только для заданных каналов',
  v3AllChannels: 'Доступно для всех каналов',
  v3SpecificProducts: 'Только заданные предметы',
  v3AllProducts: 'Для любых предметов',
  v3NotYetTimeToUse: 'Пока недоступно',
  v3Expired: 'Срок истёк',
  v3Used: 'Использовано',
  v3ValidityPeriod: 'Срок действия:',
  v3ConfirmUse: 'Принять',
  v3ChangeProduct: 'Сменить предмет',
  v3ConfirmPaymentOrder: 'Одобрить заказ',
  v3StoredValueRole: 'Персонаж для покупки',
  v3TotalNProducts: 'Всего предметов: ${n}',
  v3SelectPaymentMethod: 'Выберите способ оплаты',
  v3PayNow: 'Заплатить',
  v3MorePaymentMethods: 'Больше способов оплаты',
  v3NoAvailablePaymentMethodContactSupport:
    'Не можете найти доступные вам способы оплаты? Обратитесь в службу поддержки.',
  v3AvailableCoupons: 'Доступные купоны',
  v3Extra10Percent: '0.1',
  v3LastSelection: 'Предыдущее',
  v3RecommendedUsage: 'Рекомендуемое',
  v3PopularChoice: 'Популярное',
  v3PaymentSuccess: 'Оплата выполнена',
  v3PaymentFailure: 'Не удалось оплатить',
  v3TopUpFailureMessage:
    'Извините, не удалось пополнить счёт. Попробуйте повторить заказ или обратитесь в службу поддержки.',
  v3Game: 'Игра',
  v3UID: 'UID',
  v3OrderNumber: 'Заказ No.',
  v3ProductContent: 'Данные предмета',
  v3ViewProductDetails: 'Описание предмета',
  v3PaymentMethod: 'Способ оплаты',
  v3Complete: 'Завершить',
  v3TopUpAgain: 'Повторить покупку',
  v3FriendlyReminderSaveOrderInfo:
    'Напоминание: Сделайте скриншот, чтобы сохранить данные заказа и ускорить обработку.',
  v3RechargeAgain: 'Повторить покупку',
  v3TransactionInProgress: 'Обработка транзакции',
  v3CompletePaymentInChannel:
    'Перейдите к каналу оплаты, чтобы завершить платёж.',
  v3RestAssuredFastDeliveryAfterPayment:
    'Товар будет отправлен вам сразу после получения результата оплаты.',
  v3SaveOrderInfoForProgress:
    'Сделайте скриншот информации заказа, чтобы отслеживать прогресс транзакции.',
  v3PaymentCompleted: 'Платеж завершен',
  v3AddToHomeScreen: 'Добавить на Главный экран',
  v3AddShortcutForBonus: 'Добавьте ссылку, чтобы получить награды',
  v3ShareSuccess: 'Поделился',
  v3ShareFailure: 'Не удалось поделиться',
  v3RewardClaimed: 'Награда получена',
  v3RewardClaimFailed: 'Не удалось получить награду',
  v3EventNotStarted: 'Событие ещё не началось.',
  v3EventEnded: 'Событие завершилось',
  v3ClickSelectCoupon: 'Нажмите, чтобы выбрать купон',
  v3CouponsRecommendedUsed: 'Использован рекомендованный купон',
  v3CouponsSelected: 'Выбранный купон',
  v3NoCouponsAvaliable: 'Нет доступных купонов',
  v3SupplementStatus: 'Статус',
  v3SupplementNormal: 'Нормально',
  v3SupplementBanned: 'Заблокирован',
  v3SupplementPendingPayment: 'Ожидает оплаты',
  v3SupplementSwitchCharacter: 'Сменить персонажа',
  v3SupplementAccountInfoInvalid: 'Недействительная информация об аккаунте',
  v3SupplementContactGSForTopUpLink:
    'Пожалуйста, свяжитесь с GS для получения ссылки на пополнение',
  v3SupplementTopUpCompleted: 'Пополнение завершено:',
  v3SupplementTotalRefundOrders: 'Всего {} заказов на возврат',
  v3SupplementPendingSupplementAmount: 'Сумма ожидаемой оплаты:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Аккаунт/персонаж в норме, оплата не требуется',
  v3SupplementEnjoyYourGame: 'Приятной игры!!',
  v3SupplementOrderInformation: 'Информация о заказе',
  v3SupplementPendingPaymentAmount: 'Сумма к оплате:',
  v3LookUpCouponRule: 'Правила выдачи купонов',
  v3SwitchOldVersion: 'Сменить на старую Платёжную платформу',
  v3FirstTopUpGiveaway: 'Бонус 1-й покупки',
  v3SecureConnection: 'Устанавливаем защищённое соединение',
  v3RequestTimeOut: 'Время ожидания истекло. Повторите попытку позже.',
  v3ConfirmLeave: 'Выйти?',
  v3NoSubmitOrder:
    'Вы не оформили заказ. Если вы покинете страницу, товары могут быть утеряны.',
  v3ContinueSubmit: 'Продолжить',
  v3LeaveSubmit: 'Выйти',
  v3RecentBug: 'Недавние покупки',
  v3PwaTapShareOrMenuIcon: 'Нажмите значок «Поделиться» или «Меню» на панели инструментов браузера',
  v3PwaFindAndTapAddToHomeScreen: 'Найдите и нажмите «На экран "Домой"» в параметрах'
};
